import { createStore } from 'solid-js/store';
import app from '~/app';
import { AddressEditor } from '~/components';

import type { Subscription } from '~/lib';

export const AddApprovedBody = ( props: { subscription: Subscription } ) => {
	const [approvedBody, setApprovedBody] = createStore( { name: '', riasId: '', scheme: '', address: {}, coordinator: {name: '', email: '', telephone: ''}, deputy: {name: '', email: '', telephone: ''} } );

	return (
		<form class="w-full">
			<input type="hidden" name="approved-body[id]" id="approved-body-id" value="0" />
			<input type="hidden" name="approved-body[subscription-id]" id="approved-body-subscription-id" value="0" />

			<div id="edit-approved-body" class="row">
				<div class="form-group">
					<label class="control-label col-xs-3" for="approved-body[address-id]">Company</label>
					<div class="col-xs-9">
						<AddressEditor
							address={{ ...approvedBody.address, title: approvedBody.name }}

							setAddress={addr => setApprovedBody( "address", addr )} />
					</div>
				</div>

				<h4 class="w-full text-center">Certification Co-ordinator</h4>
				<div class="form-group">
					<label class="control-label col-xs-3" for="approved-body[coordinator][name]">Name</label>
					<div class="col-xs-9">
						<input type="text" class="form-control" name="approved-body[coordinator][name]" id="approved-body-coordinator-name" required />
						<div class="help-block with-errors"></div>
					</div>
				</div>

				<div class="form-group">
					<label class="control-label col-xs-3" for="approved-body[coordinator][email]">Email</label>
					<div class="col-xs-9">
						<input type="email" class="form-control" name="approved-body[coordinator][email]" id="approved-body-coordinator-email" required />
						<div class="help-block with-errors"></div>
					</div>
				</div>

				<div class="form-group">
					<label class="control-label col-xs-3" for="approved-body[coordinator][telephone]">Telephone No:</label>
					<div class="col-xs-9">
						<input type="text" class="form-control" name="approved-body[coordinator][telephone]" id="approved-body-coordinator-telephone" required />
						<div class="help-block with-errors"></div>
					</div>
				</div>

				<h4  class="w-full text-center">Deputy Co-ordinator <span class="text-sm">(optional)</span></h4>
				<div class="form-group">
					<label class="control-label col-xs-3" for="approved-body[deputy][name]">Name</label>
					<div class="col-xs-9">
						<input type="text" class="form-control" name="approved-body[deputy][name]" id="approved-body-deputy-name" />
					</div>
				</div>

				<div class="form-group">
					<label class="control-label col-xs-3" for="approved-body[deputy][email]">Email</label>
					<div class="col-xs-9">
						<input type="email" class="form-control" name="approved-body[deputy][email]" id="approved-body-deputy-email" />
					</div>
				</div>

				<div class="form-group">
					<label class="control-label col-xs-3" for="approved-body[deputy][telephone]">Telephone No.</label>
					<div class="col-xs-9">
						<input type="text" class="form-control" name="approved-body[deputy][telephone]" id="approved-body-deputy-telephone" />
					</div>
				</div>
			</div>
		</form>
	);
}